/**
 * Innovation Success Message
 * Javascript functionality for innovation success message pop up.
 * @version 1.0.0
 * @exports InnovationSuccessMessage
 */
export default class InnovationSuccessMessage {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		this.body = document.getElementsByTagName('BODY')[0];

		// Modal form elements
		this.ModalForm = document.getElementById('success-message');
		this.ModalFormClose = document.getElementById('success-message-close');
		this.ModalFormCancel = document.getElementById('success-message-cancel');
		this.ModalContainer = document.getElementById('success-message-container');
		this.SuccessMessageBtn = document.getElementById('success-message-button');
		this._initModalBox();
	}

	/**
	 * Closes the menu.
	 * @public
	 */
	closePane(pane) {
		if (pane.getAttribute('id') === 'success-message') {
			this.body.classList.remove('modal-open');
			setTimeout(() => {
				this.body.classList.remove('modal-is-visible');
			}, 100);
		}

		this.ModalContainer.innerHTML = '';

		pane.setAttribute('aria-hidden', true);
		pane.style.display = 'none';
	}
	/**
	 * Function that initiate the side menu on desktop.
	 * @private
	 */
	_initModalBox() {
		if (this.ModalBtn) {
			this.ModalBtn.addEventListener('click', e => {
				e.preventDefault();

				this.openPane(this.ModalForm, this.ModalBtn);
			});
		}

		if (this.ModalFormClose) {
			this.ModalFormClose.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.ModalForm);
			});
		}

		if (this.ModalFormCancel) {
			this.ModalFormCancel.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.ModalForm);
			});
		}

		if (this.ModalPageCover) {
			this.ModalPageCover.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.ModalForm);
			});
		}

		if (this.SuccessMessageBtn) {
			this.SuccessMessageBtn.addEventListener('click', e => {
				e.preventDefault();
				this.closePane(this.ModalForm);
			});
		}
	}
}
